<template>
  <div style="text-align: center">
    <span class="highlight value">{{ value }}</span> <span class="unit">{{ unit }}</span>
    <my-divider height="10px"></my-divider>
    <span>{{ name }}</span>
  </div>
</template>

<script>
import MyDivider from "@/components/MyDivider";

export default {
  name: "NameValueVerticalWithUnit",
  components: {MyDivider},
  props: ['name', 'value', 'unit']
}
</script>

<style scoped lang="scss">
span.highlight {
  font-weight: bold;
  font-size: 30px;
  color: #28CCCB;
}

span.value{
}

span.unit{
}
</style>
